import React from 'react';
import {
  CarouselPresentationContainer,
  CarouselPresentationContainerProps,
} from '../../CarouselPresentationContainer/CarouselPresentationContainer';
import { Carousel, CarouselProps } from '@jbhi-fi/lanyard-ui/components/Carousel/Carousel';
import { ContentCard, ContentCardProps } from '../ContentCard';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { palette } from '@jbhi-fi/lanyard-ui/themes';

export type VideoCardCarouselProps = Omit<CarouselProps, 'children'> & {
  cards: Array<ContentCardProps>;
};

export const VideoCardCarousel = ({ cards, ...rest }: VideoCardCarouselProps) => {
  const isDesktop = useBreakpoint('md', 'up');
  return (
    <Carousel
      spaceBetween={10}
      slidesPerView="auto"
      slidesOffsetAfter={2}
      showProgressBar
      showArrows={isDesktop}
      showPagination={false}
      fullHeightItems={true}
      fullBleed={!isDesktop}
      {...rest}
    >
      {cards.map((card, i) => (
        <ContentCard key={i} width="345px" {...card} />
      ))}
    </Carousel>
  );
};

export type PresentationVideoCardCarouselProps = Omit<CarouselPresentationContainerProps, 'children'> &
  VideoCardCarouselProps;

export const PresentationVideoCardCarousel = ({
  cards,
  coverImageSrc,
  coverImageAlt,
  coverContent,
  ...rest
}: PresentationVideoCardCarouselProps) => {
  const isDesktop = useBreakpoint('md', 'up');

  return (
    <CarouselPresentationContainer
      coverImageSrc={coverImageSrc}
      coverImageAlt={coverImageAlt}
      coverContent={coverContent}
      carouselType="video"
    >
      <VideoCardCarousel
        cards={cards}
        backgroundColor={palette.primary.light}
        outerSpacing={isDesktop ? 4 : 1}
        {...rest}
      />
    </CarouselPresentationContainer>
  );
};
